import axios from "./configs/axiosConfig";

export const getDealerRegistrationList = async () => {
  const url = `dealerregister`;
  return await axios.get(url);
};

export const verifyUserRegistered = async (email) => {
  const url = `dealerregister/userverify?email=${email}`;
  return await axios.get(url);
};

export const disableUser = async (data) => {
  const url = `dealerregister/userstatus`;
  return await axios.put(url, data);
};
export const updateReleaseNotesStatus = async (id) => {
  const url = `dealerregister/${id}/updatereleasenotestatus`;
  return await axios.patch(url);
};
